import MainNav from "../components/MainNav";

export default function HomePage(){
    return(
        <MainNav />
    )
}